import React from 'react';
import styled from 'styled-components';

import CtaLink from '../../common/ui/CtaLink';

const Banner = (props) => {
  const { mode } = props;

  const linkColor = mode === 'dark' ? 'rgb(240, 142, 50)' : 'rgb(16, 48, 174)';

  return (
    // <Notification mode={mode}>
    //   Commerce7 has welcomed 400+ wineries since acquiring WineDirect&apos;s
    //   SaaS division.{' '}
    //   <CtaLink to="/get-started" color={linkColor}>
    //     Ready to migrate?
    //   </CtaLink>
    // </Notification>
    <Notification mode={mode}>
      AI, Reporting and Insights. Join us September 9 for C7 Innovate.{' '}
      <CtaLink
        to="https://events.commerce7.com/c7-innovate-2025?utm_campaign=18846841-C7%20Innovate%202025&utm_source=website&utm_medium=banner"
        color={linkColor}
      >
        Save your spot
      </CtaLink>
    </Notification>
  );
};

const Notification = styled.p`
  width: 100%;
  text-align: center;
  background-color: ${({ mode }) =>
    mode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgb(239, 241, 247)'};
  position: absolute;
  top: 116px;
  color: ${({ mode }) => (mode === 'dark' ? 'white' : 'rgb(45, 48, 62)')};
  letter-spacing: 0.3px;
  line-height: 26px;
  padding: 17px 10px;
  font-size: 17px;
`;

export default Banner;
